import React from "react";
import { IHouse } from "../../interfaces/intarfaces";
export const prepareMessageText = (messageText: string) => {
  const lines = messageText.split("\n");
  return (
    <>
      {lines.map((line, index) => {
        if (index !== lines.length - 1) {
          return (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          );
        }
        return <React.Fragment key={index}>{line}</React.Fragment>;
      })}
    </>
  );
};

// export const calculateHousePrice = (house: IHouse, days?: number): number => {
//   if (typeof days === "number") {
//     return Math.round((days / 30) * house.price!);
//   }
//   return house.price!;
// };

export const calculateHousePrice = (house: IHouse, days?: number): number => {
  let total = 0;

  if (typeof days === "number") {
    total = Math.round((days / 30) * house.price!);
  } else {
    total = house.price!;
  }

  // Check if additional_expenses is defined and numeric, then add it to the total
  if (house.additional_expenses && !isNaN(house.additional_expenses)) {
    total += house.additional_expenses;
  }

  return total;
};
